import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { tokens } from './tokens';

let theme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: tokens.color.primary,
            light: tokens.color.primary90,
            lighter: tokens.color.primary90,
            lightest: tokens.color.primary08,
            hover: tokens.color.primary04,
            contrastText: '#ffffff',
        },
        secondary: { main: tokens.color.secondary },
        background: {
            default: tokens.color.bgDefault,
            paper: tokens.color.bgPaper,
            light: tokens.color.bgLight,
            tableHeader: tokens.color.bgTableHeader,
        },
        text: {
            primary: tokens.color.textPrimary,
            secondary: tokens.color.textSecondary,
            dark: tokens.color.textDark,
            medium: tokens.color.textMedium,
        },
        divider: tokens.color.divider,
        border: { main: tokens.color.border, light: tokens.color.borderLight },
        warning: {
            main: tokens.color.warning,
            background: tokens.color.warningBg,
            border: tokens.color.warningBorder,
            text: tokens.color.warningText,
        },
        error: { main: tokens.color.error, background: tokens.color.errorBg },
        success: { main: tokens.color.success, background: tokens.color.successBg },
        info: { main: tokens.color.info, background: tokens.color.infoBg },
    },
    typography: {
        fontFamily: tokens.font.family,
        fontSize: 14,
        fontWeightLight: 400,
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        fontWeightBold: 700,
        h1: {
            fontSize: '2rem',
            fontWeight: 600,
            letterSpacing: '-0.01em',
            color: tokens.color.textDark,
            lineHeight: 1.2,
        },
        h2: { fontSize: '1.5rem', fontWeight: 600, color: tokens.color.textDark, lineHeight: 1.25 },
        h3: { fontSize: '1.25rem', fontWeight: 500, color: tokens.color.textDark, lineHeight: 1.3 },
        h4: { fontSize: '1rem', fontWeight: 600, color: tokens.color.textDark, lineHeight: 1.4 },
        h5: { fontSize: '0.875rem', fontWeight: 600, color: tokens.color.textDark, lineHeight: 1.4 },
        body1: { fontSize: '0.875rem', lineHeight: 1.5 },
        body2: { fontSize: '0.8125rem', color: tokens.color.textSecondary, lineHeight: 1.5 },
        caption: { fontSize: '0.75rem', color: tokens.color.textSecondary, lineHeight: 1.5 },
        overline: { fontSize: '0.6875rem', fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase' },
    },
    breakpoints: {
        values: { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1536 },
    },
    shape: { borderRadius: tokens.radius.base },
    spacing: tokens.spacing,
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                html: { boxSizing: 'border-box' },
                '*, *::before, *::after': { boxSizing: 'inherit' },
                body: {
                    margin: 0,
                    padding: 0,
                    backgroundColor: tokens.color.bgDefault,
                    color: tokens.color.textPrimary,
                    WebkitFontSmoothing: 'antialiased',
                    MozOsxFontSmoothing: 'grayscale',
                },
                '*:focus-visible': {
                    outline: `2px solid ${tokens.color.primary}`,
                    outlineOffset: '2px',
                    borderRadius: '6px',
                },
                '@media (prefers-reduced-motion: reduce)': {
                    '*, *::before, *::after': {
                        animationDuration: '0.001ms !important',
                        animationIterationCount: '1 !important',
                        transitionDuration: '0.001ms !important',
                        scrollBehavior: 'auto !important',
                    },
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    borderRadius: tokens.radius.base,
                    fontWeight: 500,
                },
                containedPrimary: {
                    fontWeight: 700,
                    boxShadow: tokens.shadow.primary,
                    '&:hover': { boxShadow: tokens.shadow.primaryHover },
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: { borderRadius: tokens.radius.card },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    backgroundColor: tokens.color.bgPaper,
                    borderRadius: tokens.radius.base,
                },
            },
        },
    },
});

theme = responsiveFontSizes(theme);

export { theme };
